import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheckCircle,
  faTimesCircle,
  faShoppingCart,
  faTrashAlt,
  faDollarSign,
  faInfoCircle,
  faCaretUp,
  faCaretDown,
  faCalendarAlt,
} from '@fortawesome/free-solid-svg-icons';
// import { far } from '@fortawesome/free-regular-svg-icons';
// import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faCheckCircle,
  faTimesCircle,
  faShoppingCart,
  faTrashAlt,
  faDollarSign,
  faInfoCircle,
  faCaretUp,
  faCaretDown,
  faCalendarAlt,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

export default {
  name: 'icons',
};
